import PropTypes from 'prop-types';
import Wordmark from '../../../UISystem/Wordmark';
import ContactIconRow from '../../../UISystem/Icons/ContactIconRow';
import { ButtonRounded } from '../../../UISystem/Buttons';
import { COLORS } from '../../../../styles/UISystem';
import { DownloadSimple } from '@phosphor-icons/react/dist/ssr/DownloadSimple';

/**
 * AnonCardLanding — the sans-chat lo-fi landing card (tiered-exchange Plan 1,
 * Step 2; mock anon_2_Initial-Card_A). Business-card fidelity, deliberately:
 * wordmark, the host's name as hero, channel icons (no photo — the face lands
 * on the detail card), then the honest pair — Share back (give and get) /
 * Just save (just get). Both keep the connection; formation runs underneath
 * in AnonExchangeFlow either way.
 *
 * View gate only — rendered behind the variant seam (isSansChatVariant, the
 * CARD/TEXT branch) while the landing gate (hasAnonParticipation) says this
 * room is virgin.
 *
 * D3: the channel row height is reserved so icons filling in a beat after the
 * name causes no layout jump. Tier ruling: single phone icon (no call/SMS
 * split at Anon), no app-chat door.
 */
const AnonCardLanding = ({ profileData, onShareBack, onJustSave }) => {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: COLORS.WHITE,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Wordmark style={{ marginTop: 'calc(env(safe-area-inset-top) + 48px)' }} />

      {/* Host identity — name as hero, channels a beat behind (reserved height) */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <div
          style={{
            fontSize: '30px',
            fontWeight: '700',
            color: '#000000',
            textAlign: 'center',
            padding: '0 24px',
          }}
        >
          {profileData?.name || ''}
        </div>
        <div style={{ minHeight: '56px', marginTop: '8px' }}>
          <ContactIconRow contactData={profileData || {}} showAppChat={false} splitPhone={false} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '14px',
          paddingBottom: 'calc(48px + env(safe-area-inset-bottom))',
        }}
      >
        <ButtonRounded
          text="Share back"
          onClick={onShareBack}
          variant="primary"
          size="auto"
          style={{ minWidth: '170px' }}
        />
        <ButtonRounded
          text={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              Just save
              <DownloadSimple size={18} />
            </span>
          }
          onClick={onJustSave}
          variant="secondary"
          size="auto"
          style={{ minWidth: '170px' }}
        />
      </div>
    </div>
  );
};

AnonCardLanding.propTypes = {
  profileData: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
  }),
  onShareBack: PropTypes.func.isRequired,
  onJustSave: PropTypes.func.isRequired,
};

export default AnonCardLanding;
